import { Injectable, Injector, OnInit } from "@angular/core";
import { StoreService } from "../store";
import { ObservablesService } from "../../Services/observables/observables";
import { ActionApiService } from "../action-api/action-api.service";

const SESSION_TIMEOUT_IN_MILLISECONDS = 1000 * 60 * 5; // 5 minutes
@Injectable()
export class SessionTimeoutService {
  context: string = "page";
  intervalPromise: any;
  ajaxInfo: any;
  constructor(
    private storeService: StoreService,
    private observablesService: ObservablesService,
    private actionApiService: ActionApiService
  ) {
    // init timer
    this.init();
    this.stop = this.stop.bind(this);
    this.ctx = this.ctx.bind(this);

    this.observablesService.sessionStart.subscribe(() => {
      this.ctx();
    });

    this.observablesService.sessionStop.subscribe(() => {
      this.stop();
    });
  }

  init() {
    this.intervalPromise = setInterval(
      () => this.pingRequest(),
      SESSION_TIMEOUT_IN_MILLISECONDS
    );
  }

  pingRequest() {
    const action = "Ping";
    const stage = this.storeService.getState().data.ui.page.stage;
    this.ajaxInfo = {
      action: action,
      stage: stage
    };
    this.actionApiService.ajaxAction(this.ajaxInfo, this.context);
  }

  ctx() {
    this.context = "page";
  }

  stop() {
    clearInterval(this.intervalPromise);
  }
}
